import { GameData } from "../gamestate/gameData";

//Create  a gameTile that contain all the animatiion within a movieclip and play in loop only the reqired animation.

export class GameTile {

	private parent: PIXI.Container;
	private sizeX: number;
	private sizeY: number;
	private tileImgName: Array<string>;
	private tileImgStart: Array<number>;
	private tileImgEnd: Array<number>;
	private tileStartFrame: Array<number>;
	private framesPerAnimation: Array<number>;
	private totalFrames: number;
	private extraSpinStyle: PIXI.TextStyle;
	private activeGameData: GameData;
	private addSpinText: PIXI.Text;
	private addSpinTextTweenIn: PIXI.tween.Tween;
	private activeIndex: number;
	private scaleTween: PIXI.tween.Tween;
	private parentContainer: PIXI.Container;
	private movieClip: PIXI.extras.AnimatedSprite;
	private defaultScale:number;

	constructor(parent: PIXI.Container, activeGameData: GameData) {
		this.parent = new PIXI.Container();
		parent.addChild(this.parent);
		this.activeGameData = activeGameData;
		this.sizeX = this.activeGameData.cardsize * 1;
		this.sizeY = this.activeGameData.cardsize * 1;

		this.parentContainer = new PIXI.Container();

		this.movieClip;//contains all the animations possible on single clip;
		this.activeGameData = activeGameData;
		this.tileImgName = this.activeGameData.tileImgName;
		this.tileImgStart = this.activeGameData.tileImgStart;
		this.tileImgEnd = this.activeGameData.tileImgEnd;
		this.tileStartFrame = [];
		this.framesPerAnimation = [];

		this.totalFrames = 0;//re-defined later


		//Bonus game +1 display
		this.extraSpinStyle = new PIXI.TextStyle({
			fontFamily: this.activeGameData.gameTextStyle.gameFont,
			fontSize: 50,
			fill: '#ffffff',
			fontWeight: "bold",
			lineHeight: 60,
			align: 'center',

			dropShadow: true,
			dropShadowColor: '#000000',
			dropShadowBlur: 10,
			dropShadowAngle: Math.PI / 6,
			dropShadowDistance: 0
		});
		this.addSpinText = new PIXI.Text("+1\n " + this.activeGameData.gameTextGeneral.spin, this.extraSpinStyle);
		this.addSpinTextTweenIn;

		this.createMovieClip();
		//GENERATE GAME DECK WHEN GAME IS OPENED ,

		if (this.activeGameData.diceCounter < 5) {
			this.activeIndex = Math.floor(Math.random() * 3);//--initial DECKS 

		}
		else if (this.activeGameData.diceCounter < 10) {
			this.activeIndex = Math.floor(Math.random() * 3) + 3;//--initial DECKS 

		}
		else {
			this.activeIndex = Math.floor(Math.random() * 6);//--initial DECKS 
		}



		// console.log(this.activeIndex);
		this.activeGameData.diceCounter++;
		// this.activeIndex=9

	}

	private createMovieClip=():void=> {

		let frames = [];
		let tileindex = 0;
		let currentTileImage = (this.tileImgName[tileindex]);



		for (var i = 0; i < this.tileImgName.length; i++) {

			for (var j = this.tileImgStart[i]; j < this.tileImgEnd[i]; j++) {

				if (j < 10) {
					frames.push(PIXI.Texture.fromFrame(currentTileImage + '_0000' + j + '.png'));

				}
				else {
					frames.push(PIXI.Texture.fromFrame(currentTileImage + '_000' + j + '.png'));
				}

			}


			tileindex++

			currentTileImage = (this.tileImgName[tileindex]);
		}

		for (var i = 0; i < this.activeGameData.tileImgNameBlurred.length; i++) {
			let framename = this.activeGameData.tileImgNameBlurred[i] + ".png";
			frames.push(PIXI.Texture.fromFrame(framename));
			// console.log(framename)

		}

		this.movieClip = new PIXI.extras.AnimatedSprite(frames);
		this.movieClip.animationSpeed = .35;//diceSpeed

		this.movieClip.height = this.sizeY;
		this.movieClip.width = this.sizeX;

		this.defaultScale=this.movieClip.scale.x
		this.movieClip.anchor.set(.5);

		this.movieClip.x = this.movieClip.width / 2;
		this.movieClip.y = this.movieClip.height / 2;

		this.parentContainer.addChild(this.movieClip);


		//extra spin position
		this.parentContainer.addChild(this.addSpinText);
		this.addSpinText.anchor.set(.5)
		this.addSpinText.position.set(this.parentContainer.width / 2 - this.addSpinText.width / 3, this.parentContainer.height / 2 - this.addSpinText.height / 3);

		this.addSpinText.alpha = 0;
		this.getStartingFrame();

		this.addSpinTextTweenIn = PIXI.tweenManager.createTween(this.addSpinText);
		this.addSpinTextTweenIn.from({ alpha: 0, scale: { x: 3, y: 3 } }).to({ alpha: 1, scale: { x: 1, y: 1 } });
		this.addSpinTextTweenIn.time = 1500  //get speed from winline animation
		this.addSpinTextTweenIn.easing = PIXI.tween.Easing.outBack();
		this.addSpinTextTweenIn.loop = true;
		// this.addSpinTextTweenIn.start();

		this.parent.addChild(this.parentContainer);



		this.scaleTween = PIXI.tweenManager.createTween(this.movieClip);
		this.scaleTween.from({ alpha: 1, scale: { x: this.defaultScale, y: this.defaultScale}, rotation: 0 }).to({ alpha: 1, scale: { x: this.defaultScale, y:this.defaultScale }, rotation: 0 });
		this.scaleTween.time = 1000;
		this.scaleTween.easing = PIXI.tween.Easing.outBack();
		this.scaleTween.loop = true;
		this.scaleTween.pingPong = true;
		// this.scaleTween.start();


		this.setWinTweenActive(false);
		// this.setBlackenTint(true)
	}


	// extraSpinParent(parent:PIXI.Container)
	// {
	// 	parent.addChild(this.addSpinText)
	// }

	
	public setCurrentFrame=(imageIndex: number):void=> {

		this.movieClip.onFrameChange = null
		this.activeIndex = imageIndex;
		let startFrame = this.tileStartFrame[imageIndex] +8;//offset
		this.movieClip.gotoAndStop(startFrame);//--bc the 
		this.setWinTweenActive(false);
	}


	public setCurrentFrameBlurred=(index: number):void=> {
		// this.setBlackenTint(true);
		this.movieClip.onFrameChange = null
		this.activeIndex = index;
		let startFrame = this.movieClip.totalFrames - (this.activeGameData.tileImgNameBlurred.length - index);
		// let startFrame=this.tileStartFrame[index]+10;	
		this.movieClip.gotoAndStop(startFrame);//--bc the 
		this.setWinTweenActive(false);

	}

	public setBlackenTint=(bool:boolean):void=>
	{	
		// console.log(bool)
		this.movieClip.tint=bool?0x666666:0xffffff;
	}

	public setUsedGiftBoxTint=(bool:boolean):void=>
	{	
		// console.log(bool)
		// this.movieClip.tint=bool?0x221111:0xffffff;
	
		this.movieClip.alpha=bool?.5:1;
	}

	public setLoopAndPlay=():void=> {
		
		if (!this.movieClip.playing) {
			this.movieClip.onFrameChange = null;

			let startFrame = this.tileStartFrame[this.activeIndex];
			let endFrame = startFrame + this.framesPerAnimation[this.activeIndex];

			startFrame = this.tileStartFrame[this.activeIndex];//
			// this.movieClip.gotoAndPlay(startFrame);
			this.movieClip.play();
			this.setWinTweenActive(true)
			this.movieClip.onFrameChange = function (endFrame: number, startFrame: number) {
				// console.log(this.currentFrame,startFrame,endFrame)
				if (this.currentFrame >= endFrame) {
					this.gotoAndPlay(startFrame);


				
					// console.log('ANIMATE')
				}
			}.bind(this.movieClip, endFrame, startFrame);


		}
		else {
			// console.log("movieclip active")
		}
	}

	public setAnimationLoopActive=(bool: boolean):void=> {


		if (bool) {
			this.setLoopAndPlay();

		}

		else {
			this.setCurrentFrame(this.activeIndex);

			// 
		}

	}



	private getStartingFrame=():void=> {
		this.deltaFrames();
		for (var i = 0; i < this.tileImgStart.length; i++) {
			this.tileStartFrame[i] = this.totalFrames;
			this.totalFrames += this.framesPerAnimation[i];
		}
	}

	private deltaFrames=():void=> {


		for (var i = 0; i < this.tileImgStart.length; i++) {
			this.framesPerAnimation[i] = this.tileImgEnd[i] - this.tileImgStart[i];
		}
	}


	public setExtraSpinTweenReset=():void=>
	{	
		this.addSpinTextTweenIn.reset();
		this.addSpinTextTweenIn.stop();
		this.addSpinText.alpha=0;

	}

	public getActiveIndex=():number=>
	{
		return this.activeIndex;
	}

	public setContainerPosition(posX:number,posY:number)
	{
		this.parentContainer.position.set(posX,posY)
	}

	// public getScaleTweenIsActive=():boolean=>
	// {
	// 	return this.scaleTween.active
	// }
	
	public  setWinTweenActive=(bool:boolean):void=>
	{
		if(bool)
		{	
			this.scaleTween.stop();
			this.scaleTween.reset();
			// this.setBlackenTint(true);
			// let isBonusRound=this.activeGameData.GameContext().usedInputAction==this.activeGameData.API_handler.getServerActionBonusSpin();
			// if(isBonusRound==false)
			// {
			// 	this.scaleTween.start();
			// 	this.setBlackenTint(false);
			// }
		

		
			
		}
		else
		{	
			// console.log('reset')
			// this.setBlackenTint(false);
			this.scaleTween.stop();
			this.scaleTween.reset();
			this.movieClip.scale.set(this.defaultScale)
			this.movieClip.rotation=0;
		}
	}
}
